import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { List } from 'antd'

import { Title } from '../../components/text/Title'

import { ArticleCard } from './ArticleCard'

const RelatedArticles: FC<{
  data: Maybe<Maybe<ArticleCardFragment>[]>
}> = ({ data = [] }) => {
  return data && data?.length > 0 ? (
    <List
      rowKey={(it) => `${it?.documentId}`}
      header={
        <Title level={4}>
          <FormattedMessage id={'article.related-articles'} />
        </Title>
      }
      grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }}
      dataSource={data}
      split={false}
      renderItem={(it) => (
        <List.Item>
          <ArticleCard {...it} />
        </List.Item>
      )}
    />
  ) : null
}

export { RelatedArticles }
